// extracted by mini-css-extract-plugin
module.exports = {"Container":"BuyAdditionalPackageModal_Container__1vF_C","AdditionalPackagesContent":"BuyAdditionalPackageModal_AdditionalPackagesContent__1Yp_w"};